import React from 'react';
// import styles from '../../styles/index.scss';

const Footer =()=> {

  return(
    <footer>
      {/* フッター */}
    </footer>
  )
}

export { Footer };